if($('.type-detail').length){    
    

    $('#p-detail-tabs li a').removeAttr('data-toggle').removeAttr('role')
    $('.p-data-wrapper .detail-parameters tr').each(function(){
        if($(this).find('.availability-label')){
            $(this).addClass('dostupnost')
            $(this).hide()
        }
    })
    $('.p-final-price-wrapper').wrap('<div class="price-detail"></div>').append($('.dostupnost td').clone())
    if($('.basic-description').length == 1){
        $('.p-short-description').append('<a href="#description" class="chevron-after chevron-down-after" data-toggle="tab" data-external="1" data-force-scroll="true">Zobrazit více informací</a>')
    }
    $('.p-variants-block .variant-list').each(function(){
         if($($(this).find('.variant-label')).text().match('Varianta')){
             $(this).find('.variant-label').text('Dostupné velikosti')
            $('.p-data-wrapper').append($('footer#footer .jakou-zvolit-velikost'))
            $(this).find('.variant-label').after('<span class="open-it" data-open="Velikost">Jakou zvolit velikost?</span>')
         }
    })
    $('html').on('click', '.open-it[data-open="Velikost"]', function(){
        $('body').addClass('open-velikost')
    })
    $('html').on('click', '.popup-window span.close', function(){
        $('body').removeClass('open-velikost')
    })
    if($('.extended-description').length){
        $('.extended-description').attr('id', 'extended-description')
        $('#p-detail-tabs li').first().after('<li class="shp-tab" data-width=""><a href="#extended-description" class="shp-tab-link">Parametry</a></li>')
    }
    $('.basic-description').each(function(){
        var findtable = $(this).find('#tabulka_velikosti')
        if($(findtable).length == 1){
            $(findtable).closest('table').wrap('<div class="overflow_table"></div>')
            $('#p-detail-tabs li').first().after('<li class="shp-tab" data-width=""><a href="#tabulka_velikosti" class="shp-tab-link">Tabulka velikostí</a></li>')
        }
        $(this).find('table caption').append('<span class="open-rozmery">Jak správně změřit nohu?</span>')
        $('.basic-description').append($('footer#footer .jak-spravne-zmerit-nohu'))
    })
    $('html').on('click', '.open-rozmery', function(){
        $('body').addClass('open-rozmery-popup')
    })
    $('html').on('click', '.popup-window span.close', function(){
        $('body').removeClass('open-rozmery-popup')
    })
    $('#discussion-form input[name="fullName"]').attr('placeholder', 'Jméno a příjmení *')
    $('#discussion-form input[name="email"]').attr('placeholder', 'Váš email *')
    $('#discussion-form input[name="title"]').attr('placeholder', 'Název dotazu *')
    $('#discussion-form textarea[name="message"]').attr('placeholder', 'Dobrý den, rád(a) bych se zeptala... *')
    $('#discussion-form input[value="Odeslat komentář"]').val('Přidat nový dotaz')

    $('#productDiscussion>.votes-wrap>.vote-wrap').each(function(){
        var findtime = $(this).find('>.vote-header>span>.vote-rating>.vote-time')
        var findodpovedet = $(this).find('>.vote-content>.add-comment')
        $(this).find('>.vote-header>span>.vote-name').append(findtime).append(findodpovedet)
        
    })
    $('#productDiscussion>.votes-wrap>.vote-wrap>.votes-wrap>.vote-wrap').each(function(){
        var findtime = $(this).find('>.vote-header>span>.vote-rating>.vote-time')
        var findodpovedet = $(this).find('>.vote-content>.add-comment')
        $(this).find('>.vote-header>span>.vote-name').append(findtime).append(findodpovedet)
        var findname = $(this).find('span[itemprop="name"]').text()
        var findname = findname.normalize('NFD').replace(/[^\w]/g, '').toLowerCase()
        $(this).addClass(findname)

        
    })
    if($('.flags-extra .flag-discount').length){
        $(".flag-discount span").each(function() {
            $(this).html(function(){
            return $(this).html().replace("až", "<span class='az'>Až</span>");
            })
        })
    }

    $('body').append('<div class="scrool"><div class="container"><div class="left"><div class="logo-small"><img src="/user/documents/upload/sablona-nemazat/svg/logo-small.svg"></div><div class="image">'+$('.p-image>a').html()+'</div><div class="name">'+$('.p-detail-inner-header h1').text()+'</div></div><div class="center"><ul>'+$('#p-detail-tabs').html()+'</ul></div><div class="right"><span class="buy">Koupit</span></div></div></div>')
    /*if($('.products-alternative-wrapper').length){
        url = window.location.href; 
        image = $('.p-image-wrapper .p-image a img').attr('src').replace('/big/', '/detail/')
        $('<div class="color-var"><div class="product first">'+
        '<div class="p">'+
            '<a href="'+url+'" class="image">'+
                '<img src="'+image+'">'+
            '</a>'+
        '</div>'+
    '</div></div>').insertBefore('.p-to-cart-block')

    $('.products-alternative.products-additional .products-block .product').clone().appendTo('.color-var')

    $('.color-var .product').each(function(){
        $(this).attr('value', $(this).find('span[data-micro="sku"]').text().replace(/\./g, '').replace(/-/g, '').split('/')[0])  
    })*/
 //   $(document).ready(function(){
       /* var found = {};
        $('.color-var .product').each(function(){
          var $this = $(this);
          if(found[$this.attr('value')]){
            $this.remove();
          }else{
            found[$this.attr('value')] = true;
          }
        });*/
    //  });
//}

if($('.type-detail').length){
    //    $('.link-icons').prepend('<span class="garance">Garance nejnižší ceny</span>')
    }

    $('html').on('click', '.garance', function(e){
        e.preventDefault(),
        $.colorbox({
            html: $('footer#footer .garance-ceny').closest('span').html(),
            width: 700,
            maxWidth: "95%",
            className: "garance-ceny",
            onComplete: function() {
                shoptet.validator.initValidator($("form"))
            }
        })
    });
    $("html").on("submit", ".garance-ceny #formContact", function() {
        originalni_poznamka = $('textarea.form-control').val();
        mhjmeno = $('.garance-form #fullName').val();
        mhemail = $('.garance-form #email').val();
        mhtelefon = $('.garance-form #telefon').val();
        mhlink = $('.garance-form #linktoweb').val();
        mhzprava = $('.garance-form #zprava').val();
        nova_poznamka = 'Jméno a příjmení: ' + mhjmeno + '    ------\nE-mail: ' + mhemail + '    ------\nTelefon: ' + mhtelefon + '    ------\nOdkaz: ' + mhlink+ '   --------\nZpráva: '+mhzprava;
        $('textarea.form-control').val(nova_poznamka)
      });

    


}